import { Button, Flex, Link, Tooltip } from '@chakra-ui/react'
import { useContext, useEffect } from 'react'
import { baseUrl } from '../../hooks'
import { useApp } from '../../hooks/useApp'
import { useUrl } from '../../hooks/useDocuments'
import { useGetIpid } from '../../hooks/useInsuranceParams'
import { Document, Duplicate, Email, Print } from '../../icons'
import { insuranceParamsContext } from '../../layouts/Wizard'
import { useSendCalculationContext } from '../SendCalculationModal'

const insuranceParamsApiUrl = import.meta.env.VITE_INSURANCEPARAMS_VEHICLE_API
const insuranceParamsUrl = `${baseUrl}/${insuranceParamsApiUrl}`

export const OffersBottomToolbar = () => {
  const { insuranceParamsId, insuranceParams } = useContext(insuranceParamsContext)!
  const documentUrl = useUrl()
  const { app } = useApp()
  const onlyAddons = app === 'carkulka-extra'
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  const { mutateAsync: getIpidLink, data: ipid } = useGetIpid(insuranceParamsId!)
  useEffect(() => { getIpidLink() }, [])


  return (
    <Flex
      sx={{
        w: '100%',
        flexWrap: 'wrap',
        justifyContent: { base: 'start', md: 'space-between' },
        gap: 2,
      }}
    >
      <Flex sx={{ gap: 2 }}>
        <Button variant="outline" as='a' href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(onlyAddons ? `${baseUrl}/carkulka/extra/wizard/1` : `${baseUrl}/carkulka/wizard/1`)}`}>
          <Duplicate color="secondary.500" />
          Klonovat nabídku
        </Button>
      </Flex>

      <Flex sx={{ gap: 2, flexWrap: 'wrap' }}>
        {(app === 'carkulka' || app == 'cestovko' || app == 'chaloupka') && !isContracted && <SendCalculationButton />}

        {!isContracted &&
          <Button as={Link} href={`${documentUrl}/GetOffersPdf?paramsId=${insuranceParamsId}`} target='_blank' variant="outline" type="button">
            <Print color="secondary.500" />
            Tisk
          </Button>
        }

        {ipid?.data.ipidLink &&
          <Button as={Link} href={ipid.data.ipidLink} target='_blank' variant="outline" type="button">
            <Document color="secondary.500" />
            IPID dokumenty
          </Button>
        }

      </Flex>
    </Flex>
  )
}

const SendCalculationButton = () => {
  const { onOpen: openSendCalculation, isDisabled } = useSendCalculationContext()
  const disabledText = isDisabled ? 'Alespoň jedna kalkulace musí být validní a označena jako aktivní.' : ''

  return <Tooltip label={disabledText} hasArrow>
    <Button
      variant="outline"
      type="button"
      onClick={openSendCalculation}
      isDisabled={isDisabled}
    >
      <Email color="secondary.500" />
      E-mail
    </Button>
  </Tooltip>
}